module.exports = __webpack_public_path__ + "img/album10_06.e6a93238.jpg";